export const TANSTACK_OWNED_KIOSK_KEY = 'TANSTACK_OWNED_KIOSK_KEY';
export const TANSTACK_KIOSK_KEY = 'TANSTACK_KIOSK_KEY';
export const TANSTACK_KIOSK_DATA_KEY = 'TANSTACK_KIOSK_DATA_KEY';
export const TANSTACK_OWNED_OBJECTS_KEY = 'TANSTACK_OWNED_OBJECTS_KEY';
export const TANSTACK_OWNED_POINTS_KEY = 'TANSTACK_OWNED_POINTS_KEY';
export const TANSTACK_CARD_TRACKER_OBJECTS_KEY =
  'TANSTACK_CARD_TRACKER_OBJECTS_KEY';
export const TANSTACK_ONCHAIN_POINTS_KEY = 'TANSTACK_ONCHAIN_POINTS_KEY';

export const SUDO_API_ENDPOINT = 'https://api.sudofinance.xyz';
